import React from "react";
import { TMenuGroup } from "settings/_models/MenuMdl";
import styles from "./_css/subGroupsMenu.module.css";
import { LeafMenu } from "main/menu/LeafMenu";
import clsx from "clsx";

type Props = {
    subGroups: TMenuGroup[];
};

export function SubGroupsMenu(props: Props) {
    return (
        <div className={styles.container}>
            <div className={styles.arrow} />
            <div className={styles.bodyWrapper}>
                <div className={clsx(styles.body, "flex_row")}>
                    {props.subGroups.map((subGroup, index) => (
                        <div key={index} className={styles.subGroup}>
                            {subGroup.title && <h4 className={styles.title}>{subGroup.title}</h4>}
                            {subGroup.items?.map((leafMenu, index) => (
                                <LeafMenu key={index} menu={leafMenu} />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
